import { render, staticRenderFns } from "./SerialsListShort.vue?vue&type=template&id=8b1313ac"
import script from "./SerialsListShort.vue?vue&type=script&lang=js"
export * from "./SerialsListShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports